<template>
  <b-modal
    hide-header
    hide-footer
    centered
    size="md"
    id="service-clinician"
    modal-class="modal-wrappper"
  >
    <form @submit.prevent="handleShare">
      <div class="service-clinician-content">
        <h5>Clinician's report</h5>
        <clinician-report-add-email :emailsToReport.sync="emails"></clinician-report-add-email>
        <clinician-report-child-selector
          :childrens="childrens"
          :childrensIdsSelected.sync="childrenIdsSelected"
        ></clinician-report-child-selector>
      </div>
      <div class="d-flex justify-content-lg-between flex-wrap flex-gap mb-3">
        <p class="text-main font-weight-normal">Send me a copy of this report</p>
        <b-form-checkbox v-model="enableCopy" name="check-button" switch></b-form-checkbox>
      </div>
      <div class="clinician--controls d-flex flex-gap flex-wrap">
        <b-button class="rounded-pill clinician--controls__button" @click="closeModal"
          >Cancel</b-button
        >
        <b-button type="submit" variant="warning" class="clinician--controls__button"
          >Save</b-button
        >
      </div>
    </form>
  </b-modal>
</template>
<script>
import { mapGetters, mapState } from 'vuex';
import ClinicianReportAddEmail from './ClinicianReportAddEmail.vue';

import ClinicianReportChildSelector from './ClinicianReportChildSelector.vue';

export default {
  components: { ClinicianReportChildSelector, ClinicianReportAddEmail },
  data() {
    return {
      emails: [],
      childrenIdsSelected: [],
      enableCopy: false,
    };
  },
  methods: {
    openModal() {
      this.childrenIdsSelected = [];
      this.$bvModal.show('service-clinician');
    },
    closeModal() {
      this.$bvModal.hide('service-clinician');
    },
    handleAccept() {
      this.$emit('onClose', { accept: true });
      this.closeModal();
    },
    handleShare() {
      this.$emit('onShareReport', {
        emails: this.emails,
        child: this.childrenIdsSelected,
        copy_to: this.enableCopy,
      });
    },
  },
  computed: {
    ...mapGetters('parent', ['getChildrenData', 'getChildsCliniciansReport']),
    ...mapState('parent', ['childsCliniciansReport']),
    childrens() {
      const clinicianFilteredChildren = [];
      this.getChildrenData.forEach((item) => {
        const alreadyHasClinician = this.childsCliniciansReport.some(
          (x) => x?.child?.id === item?.id,
        );
        if (!alreadyHasClinician) return clinicianFilteredChildren.push(item);
      });
      return (
        clinicianFilteredChildren
          .filter((child) => child.child_enabled)
          .map((child) => {
            return {
              value: child.id,
              text: child.name,
              image: child.avatar && child.avatar.image ? child.avatar.image : null,
            };
          }) || []
      );
    },
  },
};
</script>
<style lang="scss" scoped>
.clinician--controls {
  &__button {
    @media screen and (min-width: 320px) {
      width: 100%;
    }

    @media screen and (min-width: 768px) {
      width: 47%;
    }
  }
}
</style>
